import { MaybeNull } from "types";
import { getResData, httpClient } from "utils";

export const EMISSION_FACTORS_API_PATHS = {
  EMISSION_FACTOR_SETTING: '/emissionfactorsetting',
  ADD_CUSTOM_SITE_TYPE: '/customsitetype',
  CHECK_EXISTING_SITE: "existsanybills",
  EMISSION_FACTORS: "/utility-type-conversion",
  EMISSION_FACTORS_EXPORT: "/utility-type-conversion/export",
  EMISSION_FACTORS_BY_SITE: "/utility-type-conversion/all-sites",
  EMISSION_FACTORS_BY_SITE_EXPORT: "/utility-type-conversion/all-sites/export",
  EMISSION_FACTORS_BY_SITE_ID: (siteId: any) => `/utility-type-conversion/sites/${siteId}`,
};

export const SCIENTIFIC_UNIT_API_PATHS = {
  SCIENTIFIC_UNIT: "/unit-conversions",
  CURRENCY_EXPORT: "/unit-conversions/currency/export",
  SCIENTIFIC_UNIT_EXPORT: "/unit-conversions/scientific-unit/export",
};

export interface EmissionFactorDTO {
  ch4FossilEmissionFactorRatio: number;
  ch4FossilEmissionFactorUnit: string;
  ch4NonFossilEmissionFactorRatio: MaybeNull<number>;
  ch4NonFossilEmissionFactorUnit: MaybeNull<string>;
  co2ConversionRatio: number;
  emissionFactorType: string;
  co2EmissionFactorRatio: number;
  co2EmissionFactorUnit: string;
  id: number;
  measurementUnit: string;
  n2oEmissionFactorRatio: number;
  n2oEmissionFactorUnit: string;
  region: MaybeNull<string>;
  country: MaybeNull<string>;
  countryRegion: MaybeNull<string>;
  applyTo: MaybeNull<string>;
  source: string;
  utilityTypeName: string;
  validFrom: MaybeNull<number>;
  validTo: MaybeNull<number>;
  utilitySubtype: MaybeNull<string>;
  gwp: MaybeNull<number>;
  gwpMultipliers: MaybeNull<number>;
  gwpSource: MaybeNull<string>;
  co2ConversionUnit: MaybeNull<string>;
  sourceUpdateDate: MaybeNull<string>;
  esgFloAccessDate: MaybeNull<string>;
  sourceLink: MaybeNull<string>;
}
export interface ReferencesDTO {
  fromCurrency: string;
  toCurrency: string;
  conversionValue: number;
  updatedDate: string;
  utilityType: string;
  utilitySubtype: string;
  fromUnit: string;
  toUnit: string;
  "": string;
}

export const getEmissionFactors = (): Promise<EmissionFactorDTO[]> =>
  httpClient
    .get<EmissionFactorDTO[]>(EMISSION_FACTORS_API_PATHS.EMISSION_FACTORS)
    .then(getResData);

export const getEmissionFactorsBySite = (): Promise<EmissionFactorDTO[]> =>
  httpClient
    .get<EmissionFactorDTO[]>(EMISSION_FACTORS_API_PATHS.EMISSION_FACTORS_BY_SITE)
    .then(getResData);

export const getEmissionFactorsExcel = (): Promise<any> =>
  httpClient
    .get(EMISSION_FACTORS_API_PATHS.EMISSION_FACTORS_EXPORT, { responseType: 'blob' })
    .then((response) => response.data);

export const getCurrencyExcel = (): Promise<any> =>
  httpClient
    .get(SCIENTIFIC_UNIT_API_PATHS.CURRENCY_EXPORT, { responseType: 'blob' })
    .then((response) => response.data);

export const getScientificUnitExcel = (): Promise<any> =>
  httpClient
    .get(SCIENTIFIC_UNIT_API_PATHS.SCIENTIFIC_UNIT_EXPORT, { responseType: 'blob' })
    .then((response) => response.data);

export const getEmissionFactorsBySiteExcel = (): Promise<any> =>
  httpClient
    .get(EMISSION_FACTORS_API_PATHS.EMISSION_FACTORS_BY_SITE_EXPORT, { responseType: 'blob' })
    .then((response) => response.data);

export const getEmissionFactorsBySiteId = (siteId: string): Promise<EmissionFactorDTO[]> =>
  httpClient
    .get<EmissionFactorDTO[]>(EMISSION_FACTORS_API_PATHS.EMISSION_FACTORS_BY_SITE_ID(siteId))
    .then(getResData);

export const getScientificUnit = (): Promise<ReferencesDTO[]> =>
  httpClient
    .get<ReferencesDTO[]>(SCIENTIFIC_UNIT_API_PATHS.SCIENTIFIC_UNIT)
    .then(getResData);

// Emission Factor Configuration 
export const getEmissionFactorSetting =
  (): Promise<any> =>
    httpClient
      .get<any>(EMISSION_FACTORS_API_PATHS.EMISSION_FACTOR_SETTING)
      .then(getResData);

export const checkExistingSite =
  (): Promise<any> =>
    httpClient
      .get<any>(EMISSION_FACTORS_API_PATHS.CHECK_EXISTING_SITE)
      .then(getResData);

export const addEmissionFactorSetting = (body: any) =>
  httpClient
    .put(EMISSION_FACTORS_API_PATHS.EMISSION_FACTOR_SETTING, body)
    .then(getResData);

export const addCustomSiteType = ({ body, keepDefaultSiteType }: { body: any; keepDefaultSiteType: boolean }) =>
  httpClient
    .post(
      `${EMISSION_FACTORS_API_PATHS.ADD_CUSTOM_SITE_TYPE}?keepDefaultSiteType=${keepDefaultSiteType}`,
      body
    )
    .then(getResData);

export const getCustomSiteType = () =>
  httpClient
    .get(EMISSION_FACTORS_API_PATHS.ADD_CUSTOM_SITE_TYPE)
    .then(getResData);

export const removeCustomSiteType = (body: any) =>
  httpClient
    .delete(EMISSION_FACTORS_API_PATHS.ADD_CUSTOM_SITE_TYPE, {
      data: [body],
    })
    .then(getResData);



